/**
 * Component to Add or Edit a single profile
 */
import * as React from 'react';
import { Card, Row, Col, Input, Button, DatePicker, Select, Checkbox, message, Breadcrumb } from 'antd';
import moment from 'moment';
import { IcommonProps } from '../common/props';
import '../../css/ProfileAddEdit.scss';
import Constants from '../common/constants';
import Token from '../common/token';
import LocalStorage from '../../service/localstorage';
import Auth from '../common/auth';
import Util from '../common/utils';
import service from '../../service/apolloclient.service';
import { MSGDISPLAYTIME } from '../common/constants';
import { VIEWSTATE } from '../common/constants';
import { staticProperties, STATICKEYS }  from '../common/staticProperties';
import strings from '../../eyeguide-localization/profile/strings.profile.addedit';

const Option = Select.Option;
const CheckboxGroup = Checkbox.Group;
const storage = new LocalStorage();
const dateFormat = 'MM/DD/YYYY';
const EVENT = {
    ADDPROFILE: '/profile/add/',
    EDITPROFILE: '/profile/edit/'
};

/**
 * Property definition 
 */
interface IProfileProps extends IcommonProps {
    // profileid: string; 
    // profile: any;
    save: any;
    cancel: any;
    navigationFrom: any;
    match: any;
    location: any;
}

/**
 * State definition
 */
interface IProfileState {
    classesWithErr: string;
    classesWithoutErr: string;
    errorFname:    boolean;
    errorLname:    boolean;
    sportsArr: Array<any>;
    levelVal: any;
    gender: any;
    rosterId: any;
    profile: any;
    firstname:   string ;
    lastname:    string ;
    birthdate:   any ;
    id:          string ;
    email:       string ;
    phone:       string ;
    notifyEmail: string ;
    notifyPhone: string ;
    organization: string ;
    userOrgName: string;
    rosterName: string;
    middlename: string;
}

export default class ProfileAddEdit extends React.Component<IProfileProps, IProfileState> {

    metaInfoMap: any;
    sport:       any ;

    constructor(props: IProfileProps) {
        super(props); 
        this.sport = '';
        this.state = {
            classesWithErr : 'fill errorHighlight',
            classesWithoutErr: 'fill',
            errorFname: false,
            errorLname: false,
            sportsArr: [],
            levelVal: '',
            gender: '',
            rosterId: '',
            profile: [],
            firstname:   '',
            lastname:    '',
            birthdate:    null,
            id:          '',
            email:       '',
            phone:       '',
            notifyEmail: '',
            notifyPhone: '',
            organization: '',
            userOrgName: '',
            rosterName: '',
            middlename: ''
        };
        this.metaInfoMap = undefined;
    }

    async componentDidMount() {
        Util.resetScroll();
        let roleid: number = parseInt(Token.decodeToken().roleid, 10);
        console.log('this.props.match', this.props.match.params);
        let task = Auth.getTasks().shouldReadMetaInfo;

        if (this.props.location.pathname.startsWith(EVENT.EDITPROFILE)) {
            await this.getProfileToEdit(this.props.match.params.playerid);
            staticProperties.set(STATICKEYS.selectedKey, this.state.profile.rosterid + VIEWSTATE.ROSTER);
            staticProperties.set(STATICKEYS.selectedRoster, this.state.profile.rosterid);
        } else {
            staticProperties.set(STATICKEYS.selectedKey, this.props.match.params.rosterid + VIEWSTATE.ROSTER);
            staticProperties.set(STATICKEYS.selectedRoster, this.props.match.params.rosterid);
        }
        
        console.log('componentDidUpdate', this.metaInfoMap);
        let sportArr = this.getValuesSepByComma(this.getInputValue('sport', ''));
        if (sportArr === null || sportArr.length === 0 || sportArr[0] === '' ) { 
            sportArr = [];
        }
        await this.getRoster(this.props.match.params.rosterid);
        if ((Auth.canPerformTask(roleid, task)) === true ) {
            this.metaInfoMap = Token.getRosterMetaInfoMap(this.props.match.params.rosterid);
        }
        this.setState({
            sportsArr: sportArr,
            levelVal : this.getInputValue('level', ''),
            gender: this.getInputValue('gender', ''),
            firstname: this.state.profile.firstname,
            middlename: this.getInputValue('middlename', ''),
            lastname: this.state.profile.lastname,
            id: this.getInputValue('profileID', ''),
            birthdate: this.formatDate('birthdate', ''),
            phone: this.getInputValue('phone', ''),
            email: this.getInputValue('email', ''),
            notifyEmail: this.getInputValue('notifyEmail', ''),
            notifyPhone: this.getInputValue('notifyPhone', ''),
            userOrgName: storage.getOrganizationName(),
        });
    }

    render() { 
        console.log('this.state.profile', this.state.profile);
        let sports = Constants.getSports();
        let levels = Constants.getLevels();
        this.sport = this.getInputValue('sport', '');
        let rosterid = this.state.profile instanceof Array && 
                            this.state.profile.length === 0 ? 
                            this.props.match.params.rosterid : 
                            this.state.profile.rosterid;
        console.log('addedit render', rosterid);
        // this.sport = this.getInputValue('sport', '');
        let selectedSports = [];
        selectedSports = this.getValuesSepByComma(this.getInputValue('sport', ''));
        if (selectedSports === null || selectedSports.length === 0 || selectedSports[0] === '' ) { 
            selectedSports = [];
        }
        return (
            <div className="ProfileAddEdit">
            <Card>
                <Breadcrumb>
                    <Breadcrumb.Item><a href="/dashboard">{strings.lsHomeTxt}</a></Breadcrumb.Item>
                    <Breadcrumb.Item ><a href={'/profile/' + rosterid}>
                    {this.state.rosterName + ' ' + strings.lsProfilesTxt}</a></Breadcrumb.Item>
                    <Breadcrumb.Item>
                        {this.state.profile instanceof Array && 
                        this.state.profile.length === 0 ? strings.lsAddTxt : strings.lsEditTxt}
                    </Breadcrumb.Item>
                </Breadcrumb>
                <br/>
                <h3>{this.state.profile instanceof Array && 
                    this.state.profile.length === 0 ? strings.lsAddProfileTxt : strings.lsEditProfileTxt } </h3>
            </Card>
            <Card bordered={false} style={{ margin: '24px 16px' }} >
                <Row className="row">
                    <Col xs={1} sm={1} md={5} lg={5} xl={5} />
                    <Col xs={8} sm={8} md={3} lg={3} xl={3} className="labelFrame">
                        <div className="label">
                            <span> {strings.lsFirstName}
                                <span className="labelReq"> * </span>
                             :</span>
                        </div>
                    </Col>
                    
                        <Col xs={14} sm={14} md={10} lg={10} xl={11}>
                            <Input 
                                value={this.state.firstname}
                                onChange={(val) => this.setState({firstname: val.target.value})}
                                className={this.state.errorFname ? 
                                        this.state.classesWithErr : this.state.classesWithoutErr}
                                placeholder={strings.lsFirstNamePlaceHolderTxt} 
                                autoFocus={true}
                            />
                        </Col>
                    <Col xs={1} sm={1} md={6} lg={6} xl={4}/>                   
                </Row>
                <Row className="row">
                    <Col xs={1} sm={1} md={5} lg={5} xl={5} />
                    <Col xs={8} sm={8} md={3} lg={3} xl={3} className="labelFrame">
                        <div className="label">
                            <span> {strings.lsMiddleName}
                             :</span>
                        </div>
                    </Col>
                    
                        <Col xs={14} sm={14} md={10} lg={10} xl={11}>
                            <Input 
                                value={this.state.middlename}
                                onChange={(val) => this.setState({middlename: val.target.value})}
                                className="fill"
                                placeholder={strings.lsMiddletNamePlaceHolderTxt} 
                            />
                        </Col>
                    <Col xs={1} sm={1} md={6} lg={6} xl={4}/>                   
                </Row>
                <Row className="row">
                    <Col xs={1} sm={1} md={5} lg={5} xl={5} />
                    <Col xs={8} sm={8} md={3} lg={3} xl={3} className="labelFrame">
                        <div className="label">
                            <span>   {strings.lsLastName} 
                                <span className="labelReq"> * </span>     
                            :</span>
                        </div>
                    </Col>
                    <Col xs={14} sm={14} md={10} lg={10} xl={11}>
                        <Input 
                            value={this.state.lastname} 
                            onChange={(val) => this.setState({lastname: val.target.value})}
                            className={this.state.errorLname ? this.state.classesWithErr : this.state.classesWithoutErr}
                            placeholder={strings.lsLastNamePlaceHolderTxt}
                        />
                    </Col>
                    <Col xs={1} sm={1} md={6} lg={6} xl={4}/>
                </Row>
                <Row className="row">
                    <Col xs={1} sm={1} md={5} lg={5} xl={5} />
                    <Col xs={8} sm={8} md={3} lg={3} xl={3} className="labelFrame">
                    <div className="label">{strings.lsIDTxt} :</div></Col>
                    <Col xs={14} sm={14} md={10} lg={10} xl={11}>
                        <Input 
                            value={this.state.id}
                            onChange={(val) => this.setState({id: val.target.value})}
                            className="fill" 
                            placeholder="e.g. 12345" 
                        />
                    </Col>
                    <Col xs={1} sm={1} md={6} lg={6} xl={4}/>
                </Row>
                <Row className="row">
                    <Col xs={1} sm={1} md={5} lg={5} xl={5} />
                    <Col xs={8} sm={8} md={3} lg={3} xl={3} className="labelFrame">
                    <div className="label">{strings.lsBDayTxt} :</div></Col>
                    <Col xs={14} sm={14} md={10} lg={10} xl={11}>
                        <DatePicker 
                            value={this.state.birthdate}
                            onChange={(val) => this.setState({birthdate: val})}
                            className="fill"
                            disabledDate={this.disabledFutreDate}
                            format={dateFormat}
                        />
                    </Col>
                    <Col xs={1} sm={1} md={6} lg={6} xl={4}/>
                </Row>
                <Row className="row">
                    <Col xs={1} sm={1} md={5} lg={5} xl={5} />
                    <Col xs={8} sm={8} md={3} lg={3} xl={3} className="labelFrame">
                    <div className="label">{strings.lsGenderTxt} :</div></Col>
                    <Col xs={14} sm={14} md={10} lg={10} xl={11}>
                    <Select 
                        value={this.state.gender}
                        className="fill" 
                        onChange={(val) => {this.setState({gender: val}); }}
                        disabled={this.isColumnDisabled('gender')}
                        getPopupContainer={this.getContainer}
                    >
                        <Option key="Level" value=""> {strings.lsSelectGenderTxt} </Option>
                        <Option key="1" value="1">{strings.lsMaleTxt}</Option>
                        <Option key="0" value="0">{strings.lsFemaleTxt}</Option>
                        <Option key="2" value="2">{strings.lsOtherTxt}</Option>
                        <Option key="3" value="3">{strings.lsUnspecifiedTxt}</Option>

                    </Select>
                    </Col>
                    <Col xs={1} sm={1} md={6} lg={6} xl={4}/>
                </Row>
                <Row className="row">
                    <Col xs={1} sm={1} md={5} lg={5} xl={5} />
                    <Col xs={8} sm={8} md={3} lg={3} xl={3} className="labelFrame">
                    <div className="label">{strings.lsSportTxt} :</div></Col>
                    <Col xs={14} sm={14} md={13} lg={13} xl={11}>
                        <CheckboxGroup 
                            style={{ width: '100%' }} 
                            value={this.state.sportsArr}
                            onChange={(val) => {console.log('val of sports', val);

                                                this.setState({
                                                            sportsArr: val
                                                }); }}
                            disabled={this.isColumnDisabled('sport')}
                        >
                            <Row>
                                {sports.map(x => <Col key={x} span={8}>
                                <Checkbox 
                                    value={x} 
                                    key={x} 
                                >
                                {x}                  
                                </Checkbox></Col>)}
                            </Row>
                        </CheckboxGroup>
                    </Col> 
                    <Col xs={1} sm={1} md={6} lg={6} xl={4}/>
                </Row>
                <Row className="row">
                    <Col xs={1} sm={1} md={5} lg={5} xl={5} />
                    <Col xs={8} sm={8} md={3} lg={3} xl={3} className="labelFrame">
                    <div className="label">{strings.lsLevelTxt} :</div></Col>
                    <Col xs={14} sm={14} md={10} lg={10} xl={11}>
                        <Select 
                            value={this.state.levelVal}
                            className="fill" 
                            onChange={(val) => {
                                                this.setState({
                                                    levelVal: val
                                                });
                             }}
                            placeholder="Juinor High"
                            disabled={this.isColumnDisabled('level')}
                            getPopupContainer={this.getContainer}
                        >
                        <Option key="0" value=""> {strings.lsSelectLevelTxt} </Option>
                            {levels.map( (x: any) => <Option key={x}>{x}</Option>)}
                        </Select>
                    </Col>
                    <Col xs={1} sm={1} md={6} lg={6} xl={4}/>
                </Row>
                <Row className="row">
                    <Col xs={1} sm={1} md={5} lg={5} xl={5} />
                    <Col xs={8} sm={8} md={3} lg={3} xl={3} className="labelFrame">
                    <div className="label">Email :</div></Col>
                    <Col xs={14} sm={14} md={10} lg={10} xl={11}>
                        <Input
                            value={this.state.email} 
                            onChange={(val) => this.setState({email: val.target.value})}
                            placeholder="eg johny@johnson.edu" 
                        />
                    </Col>
                    <Col xs={1} sm={1} md={6} lg={6} xl={4}/>
                </Row>
                <Row className="row">
                    <Col xs={1} sm={1} md={5} lg={5} xl={5} />
                    <Col xs={8} sm={8} md={3} lg={3} xl={3} className="labelFrame">
                    <div className="label">{strings.lsPhoneTxt} :</div></Col>
                    <Col xs={14} sm={14} md={10} lg={10} xl={11}>
                        <Input 
                            onChange={(val) => this.setState({phone: val.target.value})}
                            value={this.state.phone} 
                            placeholder="eg 123-456-789" 
                        />
                    </Col>
                    <Col xs={1} sm={1} md={6} lg={6} xl={4}/>
                </Row>
                <Row className="row">
                    <Col xs={1} sm={1} md={5} lg={5} xl={5} />
                    <Col xs={8} sm={8} md={3} lg={3} xl={3} className="labelFrame">
                    <div className="label">{strings.lsOrgTxt} :</div></Col>
                    <Col xs={14} sm={14} md={10} lg={10} xl={11}>
                        <Input 
                            disabled={true} 
                            value={
                                this.state.profile.organizationname !== undefined ? 
                                    this.state.profile.organizationname.trim() : 
                                        this.state.rosterName
                            }    
                        />
                    </Col>
                    <Col xs={1} sm={1} md={6} lg={6} xl={4}/>
                </Row>
                <Row className="row">
                    <Col xs={1} sm={1} md={5} lg={5} xl={5} />
                    <Col xs={8} sm={8} md={3} lg={3} xl={3} className="labelFrame">
                    <div className="label">{strings.lsNotifyEmailTxt} :</div></Col>
                    <Col xs={14} sm={14} md={10} lg={10} xl={11}>
                        <Input 
                            onChange={(val) => this.setState({notifyEmail: val.target.value})}
                            value={this.state.notifyEmail} 
                            placeholder="eg johny@johnson.edu, tessa.wring@company.com" 
                        />
                    </Col>
                    <Col xs={1} sm={1} md={6} lg={6} xl={4}/>
                </Row>
                <Row className="row">
                    <Col xs={1} sm={1} md={5} lg={5} xl={5} />
                    <Col xs={8} sm={8} md={3} lg={3} xl={3} className="labelFrame">
                    <div className="label">{strings.lsNotifyPhonesTxt}</div></Col>
                    <Col xs={14} sm={14} md={10} lg={10} xl={11}>
                        <Input 
                            onChange={(val) => this.setState({notifyPhone: val.target.value})}
                            value={this.state.notifyPhone} 
                            placeholder="eg 123-456-789, 456-789-0123" 
                        />
                    </Col>
                    <Col xs={1} sm={1} md={6} lg={6} xl={4}/>
                </Row>
                <Row>
                    <Col span={12} style={{padding: '10px'}}>
                     <div className="buttonRight"> 
                        <Button 
                            onClick={e => {
                                console.log('onadd', this.state.profile);
                                if (this.state.profile instanceof Array && this.state.profile.length === 0 ) {
                                    this.processProfile
                                    (this.getProfileObj(), 1, ''); // add
                                } else {
                                    this.processProfile
                                    (this.getProfileObj(), 
                                     0, 
                                     this.state.profile.playerid); // save
                                }
                            }}     
                            type="primary" 
                            style={{width: '100%'}}
                        > 
                             {this.state.profile instanceof Array && this.state.profile.length === 0 ? strings.lsAddTxt 
                                : strings.lsSaveTxt} 
                        </Button> 
                     </div>
                    </Col>
                    <Col span={12} style={{padding: '10px'}}>
                     <div className="buttonLeft"> 
                        <Button 
                                onClick={e => {
                                    history.back();
                                        // this.props.notifyCancelClick(this.props.profile !== '' ? 
                                        //                              this.props.profile.playerid : '', 
                                        //                              this.props.navigationFrom, '');
                                }} 
                                type="danger" 
                                style={{width: '100%'}}
                        > 
                        {strings.lsCancelTxt} 
                        </Button> 
                     </div>
                    </Col>
                </Row>
            </Card>
            </div>
        );
    }

    /**
     * Returns value of the property
     * @param property attribute name to extract value from props.profile
     * @param defaultVal default value, if attribute not found
     */
    private getInputValue(property: string, defaultVal: string): string {
        let metaInfoMap = this.metaInfoMap;
        let defaultValue: string = '';
        let playerinfo = this.state.profile !== '' &&  (this.state.profile !== undefined && 
                    this.state.profile.playerinfo !== undefined)
                        ? this.state.profile.playerinfo.filter((e: any) => 
                                e.playerinfoname === property) : '';
        if (playerinfo.length === 0) {
            // defaultValue = this.getDisbledColumnVal(property, this.metaInfoMap);
            if (metaInfoMap !== '' && metaInfoMap !== undefined && metaInfoMap.length > 0) {
                let metaInfo: any = metaInfoMap.filter( (x: any) => 
                    x.metainfoname === property
                );
                if (metaInfo.length > 0) {
                    defaultValue = metaInfo[0].metainfovalue;
                }
            }
        }
        return playerinfo.length !== 0 &&  playerinfo[0].playerinfovalue !== null ? 
                            playerinfo[0].playerinfovalue : defaultValue;
    }

    private disabledFutreDate(current: any) {
        // Can not select days before today and today
        return current > moment().endOf('day');
    }

    /**
     * Returns date from miliseconds.
     * @param attr date attribute whose value needs to be fetched for formatting
     * @param defaultVal default value to be set if no value provided
     */
    private formatDate(attr: string, defaultVal: string): any {
        let dobInMS = this.getInputValue(attr, defaultVal);
        if (dobInMS !== '') {
            return moment(parseInt(dobInMS, 10));
        }
    }

    /**
     * Returns profile object in json format
     * to be sent to server for processing
     */
    private getProfileObj(): any {
        if (this.validateInput()) {
            this.sport = this.getCommaSepValue(this.state.sportsArr); 
            let dob = '';     
            console.log('this.state.birthdate', this.state.birthdate) ;
            if (this.state.birthdate !== '' && this.state.birthdate !== null  
                            && this.state.birthdate !== undefined) {
                dob = this.getDateInMS(this.state.birthdate);
            }
            let inputPlayer: any = {
                'firstname': this.state.firstname !== null ? this.state.firstname.trim() : '',
                'lastname': this.state.lastname !== null ? this.state.lastname.trim() : '',
                'playerinfo': [{
                    'playerinfoname': 'gender',
                    'playerinfovalue': this.state.gender !== null ? this.state.gender : ''
                }, {
                    'playerinfoname': 'sport',
                    'playerinfovalue': this.sport !== null ? this.sport : ''
                }, {
                    'playerinfoname': 'level',
                    'playerinfovalue': this.state.levelVal !== null ? this.state.levelVal : ''
                }, {
                    'playerinfoname': 'birthdate',
                    'playerinfovalue': dob
                }, {
                    'playerinfoname': 'email',
                    'playerinfovalue': this.state.email !== null ? this.state.email.trim() : ''
                }, {
                    'playerinfoname': 'phone',
                    'playerinfovalue': this.state.phone !== null ? this.state.phone.trim() : ''
                }, {
                    'playerinfoname': 'notifyEmail',
                    'playerinfovalue': this.state.notifyEmail !== null ? 
                            this.state.notifyEmail.trim() : ''
                }, {
                    'playerinfoname': 'notifyPhone',
                    'playerinfovalue': this.state.notifyPhone !== null ? 
                            this.state.notifyPhone.trim() : ''
                }, {
                    'playerinfoname': 'profileID',
                    'playerinfovalue': this.state.id !== null ? this.state.id.trim() : ''
                },
                {
                    'playerinfoname': 'middlename',
                    'playerinfovalue': this.state.middlename !== null ? this.state.middlename.trim() : ''
                }]
                };  
            return inputPlayer;
        } else {
            return '';
        }       
    }

    /**
     * Validate input values provided by the user before submitting to server 
     */
    private validateInput(): boolean {
        let isValid: boolean = true;
        let errorFname: boolean = false;
        let errorLname: boolean = false;
        if (this.state.firstname !== null && 
                    (this.state.firstname === undefined || this.state.firstname.trim() === '' )) {   
            errorFname = true;
            console.log('this.state.errorFname', this.state.errorFname);
        } else {
            errorFname = false;
        }      
        if (this.state.lastname !== null && 
                    (this.state.lastname === undefined || this.state.lastname.trim() === '')) {
            errorLname = true;
        } else {
            errorLname = false;
        }
        if (errorFname === true || errorLname === true) {           
            isValid = false;
        } 
        this.setState({errorFname: errorFname, errorLname: errorLname});
        return isValid;
    }

    /**
     * Converts date to milliseconds i.e. returns the timestamp in UTC.
     * @param value date value
     */
    private getDateInMS(value: any) {
        let dateObj = new Date(this.state.birthdate);
        let dateInMS = new Date(
                                dateObj.getFullYear(), 
                                dateObj.getMonth(), 
                                dateObj.getDate()).getTime().toString();   
        return dateInMS;    
    }

    /**
     * Returns array of values obtained by splitting on ','
     * @param commaSepList String containing comma seperated list
     */
    private getValuesSepByComma(commaSepList: string) {
        let values: any = commaSepList !== null ? commaSepList.split(',') : [];
        if (values.length > 0) {
            return values;
        } else {
            return commaSepList;
        }
    }

    /**
     * Returns a single string containing array elements, comma seperated 
     * @param arrayToConv Array to convert into singe string seperated by commas
     */
    // private getCommaSepValue(arrayToConv: any) {
    //     let commaString: string = '';
    //     if (arrayToConv.length > 0) {
    //         arrayToConv.map(x => {
    //                 commaString += x + ',';
    //             });
    //     } else {
    //         return commaString;
    //     }
    //     console.log('commaString', commaString);
    //     return commaString.slice(0, -1);
    // } 
    
    /**
     * Reset all control values
     */
    // private resetControls() {
    //     this.setState({
    //         birthdate: '',
    //         email: '' ,
    //         firstname: '' ,
    //         lastname: '' , 
    //         id: '' , 
    //         notifyEmail: '' , 
    //         notifyPhone: '' , 
    //         phone: '' , 
    //     });
    //     this.sport = '';
    //     console.log();
    // }

    /**
     * Checks if the column is present in metainfomaps.
     * If present column must be disabled for user input.
     * @param propertyName Name of column to check
     */
    private isColumnDisabled(propertyName: string): boolean {
        console.log('disbale called');
        if (this.metaInfoMap !== '' && this.metaInfoMap !== undefined && this.metaInfoMap.length > 0) {
            let metaInfo: any = this.metaInfoMap.filter( (x: any) => 
                x.metainfoname === propertyName
            );
            if (metaInfo.length > 0) {
                return true;
            }
        }
        return false;
    }

    /**
     * sets the container element for dropdown menu
     */
    private getContainer = (triggernode) => {
        return triggernode.parentNode;
    }

    /**
     * Adds/Updates a profile
     * @param profile Profile object to add/update
     * @param event this indicates the action i.e. add or update. 1 is for add.
     */
    private async processProfile(profile: any, event: number, playerid: any) {
        console.log('value', profile);
        console.log('this.props.match.params.rosterid', this.props.match.params.rosterid);
        if (profile !== '') {
            let ser = new service();
            profile.organization = this.state.rosterName;
            if (event === 1) {
                let resp = await ser.addAthelete(profile, this.props.match.params.rosterid);
                if (resp.status === 0) {
                message.success(strings.lsAddProfileSuccessTxt, MSGDISPLAYTIME);      
                } else {
                    message.error(strings.lsAddProfileFailedTxt, MSGDISPLAYTIME);
                }

            } else {
                let newProfile = await ser.updateAthelete(profile, playerid);
                console.log('new returned profile', newProfile);
                message.success(strings.lsUpdateProfileSuccessTxt, MSGDISPLAYTIME);     
            } 
            history.back();
        } else {
            // dont do anything;
        } 
        
    }

    private async getProfileToEdit(id: any) {
        let ser = new service();
        let profile = await ser.getProfile(id);
        this.setState({profile: profile[0]});
        console.log('profile', this.state.profile); 
    }

    private async getRoster(rosterid: string) {
        if (rosterid !== '' && rosterid !== null && rosterid !== undefined) {
            let ser = new service();
            let roster = await ser.getOrganizationByRoster(rosterid);
            this.setState({rosterName: roster.name});
        } else {
            this.setState({rosterName: this.state.profile.organizationname});
        }
    }

    /**
     * Returns a single string containing array elements, comma seperated 
     * @param arrayToConv Array to convert into singe string seperated by commas
     */
    private getCommaSepValue(arrayToConv: any) {
        let commaString: string = '';
        if (arrayToConv.length > 0) {
            arrayToConv.map(x => {
                    commaString += x + ',';
                });
        } else {
            return commaString;
        }
        console.log('commaString', commaString);
        return commaString.slice(0, -1);
    } 

}



// WEBPACK FOOTER //
// ./src/components/profile/ProfileAddEdit.tsx